module.exports = __webpack_public_path__ + "img/undraw_newsletter_re_wrob.b4edcebe.svg";